import React, { useEffect, useState } from 'react';
import styles from '../../css/Part7.module.css';

function NoLostCampaign() {
  const [activeDot, setActiveDot] = useState(1);

  useEffect(() => {
    class Card {
      constructor(node, position) {
        this.node = node;
        this.position = position;
      }

      nextPosition() {
        return this.position !== 10 ? this.position + 1 : 1;
      }

      prevPosition() {
        return this.position !== 1 ? this.position - 1 : 10;
      }

      moveNext() {
        this.node.classList.replace(
          `position${this.position}`,
          `position${this.nextPosition()}`
        );
        this.position = this.nextPosition();
      }

      movePrev() {
        this.node.classList.replace(
          `position${this.position}`,
          `position${this.prevPosition()}`
        );
        this.position = this.prevPosition();
      }
    }

    const prev = document.querySelector('.prev i');
    const next = document.querySelector('.next i');
    const gallery = document.querySelector('.gallery');
    const cards = [];
    let start;

    document.querySelectorAll('.card').forEach((e, pos = 0) => {
      pos += 1;
      cards.push(new Card(e, pos));
    });

    const updateActiveDot = () => {
      const centerCard = cards.find((c) => c.position === 1);
      if (centerCard) {
        const centerCardIndex = Array.from(document.querySelectorAll('.card')).indexOf(
          centerCard.node
        );
        setActiveDot(centerCardIndex + 1);
      }
    };

    if (prev && next) {
      next.addEventListener('click', () => {
        cards.forEach((c) => c.movePrev());
        updateActiveDot();
      });

      prev.addEventListener('click', () => {
        cards.forEach((c) => c.moveNext());
        updateActiveDot();
      });
      
    } else {
      console.error('Carousel controls not found');
    }

    gallery.addEventListener('touchstart', (s) => {
      start = s.targetTouches[0].screenX;
    });

    gallery.addEventListener('touchend', (e) => {
      const end = e.changedTouches[0].screenX;
      const range = Math.abs(start - end);

      if (range > 30) {
        if (start < end) {
          cards.forEach((c) => c.moveNext());
        }

        if (start > end) {
          cards.forEach((c) => c.movePrev());
        }
        updateActiveDot();
      }
    });

    // Set initial active dot
    updateActiveDot();

    return () => {
      if (next) next.removeEventListener('click', () => {});
      if (prev) prev.removeEventListener('click', () => {});
      gallery.removeEventListener('touchstart', () => {});
      gallery.removeEventListener('touchend', () => {});
    };
  }, []);

  return (
    <main className={styles.campaignContainer}>
      <h1 className={styles.campaignTitle}>No Cost, No Lost</h1>
      <section className={styles.campaignBackground}>
        <div className={styles.contentWrapper}>
          <div className="section2-partner">
            <div className="container">
              <div className="prev">
                <i className="carousel-control-prev-icon"></i>
              </div>

              <div className="gallery">
                {/* Add your card elements here */}

                <div className="card position1">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Teppanyaki (4 Oct) website-01.jpg" alt="Chicken Teppanyaki" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                          - Minimum spending of RM50(FV) via FoneApp to get x1 free Chicken Teppanyaki Ala Cart. <br/>
                          - 1 redemption per user, per month in a single transaction for this campaign <br/>
                          - Valid at Omulah by Teppanyaki outlets as below <br/>
                          - 1 Utama Shopping Centre <br/>
                          - The Mines Shopping Mall <br/>
                          - Sungei Wang Plaza <br/>
                          - DPULZE Shopping Centre <br/>
                          - AEON Metro Prima Shopping Centre, Jalan Metro Prima, Taman Kepong <br/>
                          - AEON Taman Equine, Bandar Putra Permai <br/>
                          - Omulah Teppanyaki Bangi <br/>
                          - Campaign from 01/04/2024 - 30/09/2024 <br/>
                          - Redemption period from 01/04/2024 - 30/09/2024 <br/>
                          - Not stackable with other in-house promotions <br/>
                          - Not exchangeable for cash or any other product/service <br/>
                          - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first <br/>
                          - FoneApp reserves the right to amend the T&C at any time without prior notice <br/>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position2">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Kokomo (5 Oct) website-01.jpg" alt="kokomo" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp">
                          - Minimum spending of RM100(FV) in a single transaction via FoneApp to get RM10(FV) Instant Rebate, max capped RM10(FV) <br/>
                          - 1 redemption per user, per month in a single transaction for this campaign <br/>
                          - If full bill payment is made by any other payment method other than FoneApp, this promotion is not applicable. <br/>
                          - Valid at Kokomo Sushi & Wagyu Restaurant, Johor <br/>
                          - Campaign from 13/09/2024 - 13/10/2024 <br/>
                          - Redemption period from 13/09/2024 - 13/10/2024 <br/>
                          - Not exchangeable for cash or any other product/service <br/>
                          - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first <br/>
                          - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>

                      <h7 className="texth7">10% Voucher by Kokomo</h7>
                      <p className="textp">
                          - Only applicable for the next visit <br/>
                          - Valid at Kokomo <br/>
                          - This cash voucher entitles you to purchase any meals or drinks in Kokomo Menu <br/>
                          - This cash voucher is not redeemable for Cash <br/>
                          - This cash voucher is not replaceable is lost or stolen <br/>
                          - Non refundable for any unused amount/value <br/>
                          - Photocopy of cash voucher is not valid <br/>
                          - This voucher is valid 1 month from the date of this voucher issued. Not renewable upon expiry <br/>
                          - Kokomo reserves the right to change, modify or amend the terms and conditions above at any time without prior notice <br/>
                          - Coupon valid only with Authorised Signature and Company Stamp
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position3">
                  <div className="card-inner">  
                    <div className="card-front">
                      <img src="/images/merchant ads/Beauty in the pot (BITP)-01.jpg" alt="beauty in the pot" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM150(FV) via FoneApp to get 20% Instant Rebate, max capped RM20(FV)<br/>
                      - 1 redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid at selected Beauty In The Pot outlets (Tropicana Gardens Mall, Genting Highlands & The Gardens Mall)<br/>
                      - Campaign from 05/02/2024 - 05/03/2024 <br/>
                      - Redemption period from 05/02/2024 - 05/03/2024 <br/>
                      - Not stackable with other in-house promotions<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position4">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/DLY (6 Oct) website-01.jpg" alt="DLY" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM150(FV) in a single transaction via FoneApp to get 1x FREE Pork Belly Slice or Toman Fish<br/>
                      - 1 free dish redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid at all Da Long Yi outlets<br/>
                      - Campaign from 01/02/2024 - 31/12/2024<br/>
                      - Redemption period from 01/02/2024 - 31/12/2024<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position5">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Flying Elephant (1 Oct) website-01.jpg" alt="Flying Elephant" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM60(FV) via FoneApp to get RM10(FV) Instant Rebate<br/> 
                      - 1 redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid at Flying Elephant Restaurant in Petaling Jaya<br/>
                      - Campaign from 22/07/2024 - 22/08/2024<br/>
                      - Redemption period from 22/07/2024 - 22/08/2024<br/>
                      - Not stackable with other in-house promotions<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position6">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/FWF (3 Oct) website-01.jpg" alt="FWF" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM200(FV) via FoneApp to get 1x Pork Belly Slice or Fish Roe Lucky Bag<br/>
                      - 1 redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid at all Feng Wang Fu outlets<br/>
                      - Campaign from 19/02/2024 - 19/03/2024 <br/>
                      - Redemption period from 19/02/2024 - 19/03/2024 <br/>
                      - Not stackable with other in-house promotions<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>


                <div className="card position7">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Rosso Hair Salon website-01.jpg" alt="Rosso Hair Salon" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM50(FV) via FoneApp to get RM10(FV) Instant Rebate, max capped RM10(FV)<br/>
                      - 1 redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid at Rosso Hair Salon TTDI outlet<br/>
                      - Campaign from 23/02/2024 - 31/05/2024<br/>
                      - Redemption period from 23/02/2024 - 31/05/2024<br/>
                      - Not stackable with other in-house promotions<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>


                <div className="card position8">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Sport Heroes  website-01.jpg" alt="Sport Heroes" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM30(FV) via FoneApp to get RM10(FV) Instant Rebate <br/>
                      - 1 redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid at Sport Heroes Kota Damansara outlet<br/>
                      - Campaign from 23/02/2024 - 31/05/2024<br/>
                      - Redemption period from 23/02/2024 - 31/05/2024<br/>
                      - Not stackable with other in-house promotions<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position9">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Stuff_d (2 Oct) website-01.jpg" alt="Stuff d" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM25(FV) via FoneApp to get 15% Instant Rebate, max capped RM10(FV) <br/>
                      - 1 redemption per user, per month in a single transaction for this campaign<br/>
                      - Valid in all Stuff’d outlet within Malaysia<br/>
                      - Campaign from 04/09/2024 - 04/10/2024<br/>
                      - Redemption period from 04/09/2024 - 04/10/2024<br/>
                      - Not stackable with other in-house promotions<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>

                      <h7 className="texth7">How to redeem</h7>
                      <p className="textp"> 
                      1. Customer orders via SOK or Counter <br/>
                      2. Customer selects payment via QR/e-Wallet <br/>
                      3. Customer presents FoneApp Payment QR to Gkash Terminal or Cashier <br/>
                      4. The rebate will instantly reflect in user’s FoneApp wallet after payment is completed
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card position10">
                  <div className="card-inner">
                    <div className="card-front">
                      <img src="/images/merchant ads/Uncle Don_s (8th oct) website-01.jpg" alt="Sport Heroes" />
                    </div>
                    <div className="card-back">
                      <h7 className="texth7">Terms and conditions applied </h7>
                      <p className="textp"> 
                      - Minimum spending of RM60(FV) in a single transaction via FoneApp to get 1x Mushroom Soup with Garlic Bread OR Spaghetti Aglio Olio (Vegetarian)<br/>
                      - 1 free dish redemption per user, per month in a single transaction for this campaign<br/>
                      - If full bill payment is made by any other payment method other than FoneApp, this free dish promotion is not applicable.<br/>
                      -  Valid at all Uncle Don's outlets in Malaysia<br/>
                      - Campaign from 01/04/2024 - 31/05/2024<br/>
                      - Redemption period from 01/04/2024 - 31/05/2024<br/>
                      - Not exchangeable for cash or any other product/service<br/>
                      - First come first serve, the campaign will end once the redemption fully claimed and/(or the campaign period ended), whichever occur first<br/>
                      - FoneApp reserves the right to amend the T&C at any time without prior notice
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="next">
                <i className="carousel-control-next-icon"></i>
              </div>
            </div>

            {/* Dots Section */}
            <div className="dots">
              {Array.from({ length: 10 }).map((_, index) => (
                <span
                  key={index}
                  className={`dot ${activeDot === index + 1 ? 'active' : ''}`}
                ></span>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NoLostCampaign;
